import { render, staticRenderFns } from "./HomeBig.vue?vue&type=template&id=4514d766"
import script from "./HomeBig.vue?vue&type=script&lang=js"
export * from "./HomeBig.vue?vue&type=script&lang=js"
import style0 from "./HomeBig.vue?vue&type=style&index=0&id=4514d766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports